import { ClockComponent } from './../clock/clock.component';
import { Component, HostListener, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { TodoListItemService } from 'app/main/pages/todo-list/todo-list-item/todo-list-item.service';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, merge, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-work-status',
  templateUrl: './work-status.component.html',
  styleUrls: ['./work-status.component.scss']
})
export class WorkStatusComponent implements OnInit, OnDestroy {


  loggedInTime = Math.ceil((Date.now() / 1000));
  checkIn = this.loggedInTime;
  workStatus: string;
  workTimeInterval: NodeJS.Timeout;
  breakInSeconds = 0;
  totalBreakHoursDisplayTime: any;
  totalWorkingHoursDisplayTime: any;
  workInSeconds: number;
  isUserTimeSheetIsAvailableForToday = false;
  profileId = this.parseService.instance.User.current() ? this.parseService.instance.User.current().get('profile').id : '';
  tenantId: any;
  profileDetails: { agreedStartTime: any; isWebDesktop: any; };
  breakToasterInterval: NodeJS.Timeout;
  meetingToasterInterval: NodeJS.Timeout;
  currentWorkStatus = 'Start';
  isWorkClosed: any;
  projectList: any[];
  selectedProject: any;
  currentlyWorkingTask: any;
  isTaskInprogress = false;
  autoSaveInterval: NodeJS.Timer;
  autoSaveUpdatedTime: number;
  autoSaveIntervalMinute = 3; // 3 minutes value for auto save interval
  // tslint:disable-next-line:typedef
  @ViewChild('forgotLogoutPopup', { static: false }) forgotLogoutPopup: TemplateRef<any>;
  prviousDayTimesheetIncomplete: any;
  networkStatus = false;
  networkStatus$: Subscription = Subscription.EMPTY;

  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    console.log('Processing beforeunload...');
    // this.autoSave();
  }
  constructor(
    private dateService: DateServiceService,
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private toaster: ToastrService,
    private todoListItemService: TodoListItemService,
    private router: Router,
    public fb: FormBuilder,
    public dialog: MatDialog
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getUserProfile();
    this.todoListItemService.selectedTaskForHeader.subscribe(async (data) => {
      if (data === '') { return; } // return if empty string
      if (data !== false) {
        this.currentlyWorkingTask = data;
        // await this.checkUserTimeSheetIsAvailable();
        //  ! user start the task when break or logout state they switched to login automatically
        switch (this.currentWorkStatus) {
          case 'Logout':
            this.restartDay();
            break;

          case 'Break':
            this.resumeWork();
            break;

          default:
            break;

        }
        // * switch the project based on the selected Task
        if (this.currentlyWorkingTask.Project) {
          const currentProjectId = this.currentlyWorkingTask.Project.objectId;
          if (this.selectedProject.id !== currentProjectId) { // ! project switched to new project
            this.switchProject(currentProjectId);
          }
          this.checkTaskIsInprogress();
        }
      } else if (data === false) { // ! Hold or completed the inprogress task 
        this.storageConfiguration.sessionSetItem(this.storageConfiguration.projectId, JSON.stringify(this.selectedProject));
        setTimeout(() => {
          this.checkTaskIsInprogress();
        }, 2000);
      }
    });
  }

  ngOnInit(): void {

    /**
     * * Get the last updateted time from the localstore of autosave(function) and set to autoSaveUpdatedTime variable
     */
    let autoSaveUpdatedTime_userTimeSheet = +this.storageConfiguration.sessionGetItem(this.storageConfiguration.autoSaveUpdatedTime_userTimeSheet);
    if (autoSaveUpdatedTime_userTimeSheet) {
      autoSaveUpdatedTime_userTimeSheet = +autoSaveUpdatedTime_userTimeSheet;
    }

    /**
     * * If userTimeSheetAutoSave(localStorage)  is true call the autoSave function to sync the hours () 
     */
    const isAutoSave = this.storageConfiguration.sessionGetItem(this.storageConfiguration.userTimeSheetAutoSave);
    if (JSON.parse(isAutoSave)) {
      this.autoSave();
      this.autoSaveUpdatedTime = autoSaveUpdatedTime_userTimeSheet; // set the previous updated time value
    }


    (async () => {
      this.checkNetworkStatus();
      const prviousDayTimesheetIncomplete = await this.checkUserTimeSheetIsAvailableForYesterday();
      if (prviousDayTimesheetIncomplete && prviousDayTimesheetIncomplete.length > 0) {
        // alert('previous day timesheet updated successfully');
        this.prviousDayTimesheetIncomplete = prviousDayTimesheetIncomplete[0];
        this.previousDayUerTimeSheetLogout(); // show the previous day logout to forgot popup
        this.closeWork(prviousDayTimesheetIncomplete[0]); // close the previous day functionality
      }
      const userTimeSheet = await this.checkUserTimeSheetIsAvailable(true);
      await this.getProjectList();
      if (this.isUserTimeSheetIsAvailableForToday) { // ! time-sheet record is available for today (Patch the selected project)
        const selectedProject = userTimeSheet.get('webDesktopDetails').currentProjectSelected;
        this.selectedProject = this.projectList.find(pro => pro.id === selectedProject.id);
      } else { // ! time-sheet record not present for today (Patch the default project)
        this.selectedProject = this.projectList.find(pro => pro.projectName === 'Unassigned Project');
      }
      // * set the selected project in the local storage
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.projectId, JSON.stringify(this.selectedProject));
    })();
    this.checkTaskIsInprogress();
  }

  /**
   * * View Work and Break hours in clock popup
   */
  async viewClock(event): Promise<void> {
    // return;
    event.stopPropagation();
    const currentUserTimeSheet = await this.checkUserTimeSheetIsAvailable(true);
    const currentUserTotalAttendance = currentUserTimeSheet.get('totalAttendance');
    const dialogRef = this.dialog.open(ClockComponent, {
      width: '400px',
      height: '275px',
      data: { work: currentUserTotalAttendance.worktime, break: currentUserTotalAttendance.breaktime },
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  /**
   * * Check user task is running (InProgress)
   */
  checkTaskIsInprogress(): void {
    const taskStartTime = +localStorage.getItem('taskStartTime');
    if (taskStartTime) {
      this.isTaskInprogress = true;
    } else {
      this.isTaskInprogress = false;
    }
  }

  /**
   * @param returnUserTimeSheet (Boolen type)
   * @returns If true retrun the Result;
   */
  async checkUserTimeSheetIsAvailable(returnUserTimeSheet?): Promise<any> {
    const UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    const userTimeRecord = new this.parseService.instance.Query(UserTimeSheet);
    userTimeRecord.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    const today = new Date();
    const currentDate = this.dateService.startEndDateByDate(today);
    userTimeRecord.greaterThan('createdAt', currentDate[0]);
    userTimeRecord.lessThan('createdAt', currentDate[1]);
    const result = await userTimeRecord.find();
    if (result.length > 0) {
      localStorage.setItem('userTimeSheet', JSON.stringify(result[0]));
      this.isUserTimeSheetIsAvailableForToday = true;
      const webDesktopDetails = result[0].get('webDesktopDetails');
      this.isWorkClosed = result[0].get('isClosed');
      if (webDesktopDetails.status) {
        const statusType = webDesktopDetails.status;
        if (statusType === 'work') {
          this.currentWorkStatus = 'Work';
        } else if (statusType === 'close') {
          this.currentWorkStatus = 'Close';
        } else if (statusType === 'break') {
          if (webDesktopDetails.meeting) {
            this.currentWorkStatus = 'Meeting';
          } else {
            this.currentWorkStatus = 'Break';
          }
        } else if (statusType === 'logout') {
          this.currentWorkStatus = 'Logout';
        }

      }
    }
    if (returnUserTimeSheet) {
      return result[0];
    }
  }
  // * check userTimeSheet is not closed (offline) for previous days (last login day)
  async checkUserTimeSheetIsAvailableForYesterday(): Promise<any> {
    const UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    const userTimeRecord = new this.parseService.instance.Query(UserTimeSheet);
    userTimeRecord.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    const today = new Date();
    let yesterday = new Date();
    yesterday = new Date(yesterday.setDate(today.getDate() - 1));
    const currentDate = this.dateService.startEndDateByDate(today);
    // userTimeRecord.greaterThan('createdAt', today[0]);
    userTimeRecord.lessThan('createdAt', currentDate[0]);
    userTimeRecord.containedIn('currentStatus', ['work', 'idle']);
    userTimeRecord.equalTo('isSheetSubmitted', false);
    const result = await userTimeRecord.find();
    if (result.length > 0) {
      return result;
    }
  }


  timeCount(): void {
    this.workTimeInterval = setInterval(() => {
      if (this.workStatus === 'break') {

        this.breakInSeconds += 1;
        this.totalBreakHoursDisplayTime = this.dateService.secondsToHms(this.breakInSeconds);

      } else {

        const presentTime = Math.ceil((Date.now() / 1000));
        this.workInSeconds = presentTime - this.checkIn - this.breakInSeconds;
        this.totalWorkingHoursDisplayTime = this.dateService.secondsToHms(this.workInSeconds);

      }
    }, 1000);
  }

  autoSave(): void {
    clearInterval(this.autoSaveInterval);
    this.autoSaveUpdatedTime = new Date().getTime();
    this.storageConfiguration.sessionSetItem(this.storageConfiguration.autoSaveUpdatedTime_userTimeSheet, this.autoSaveUpdatedTime);
    this.autoSaveInterval = setInterval(async () => {
      this.autoSaveUserTimeSheet();
    }, this.autoSaveIntervalMinute * 60 * 1000);
    // }, 300000); // ! call evey 5 mins to save the work and break
  }

  /**
   * @Params (objectId : string) userTimeSheet Id
   * * get updated time if userTimeSheet variable is falsy
   */
  async getUpdatedTimeOfUserTimeSheet(objectId): Promise<any> {
    const UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    const userTimeRecord = new this.parseService.instance.Query(UserTimeSheet);
    userTimeRecord.equalTo('objectId', objectId);
    const result = await userTimeRecord.find();
    if (result.length) {
      return result[0].get('updatedTime');
    }
  }

  async autoSaveUserTimeSheet(): Promise<void> {
    const currentUserTimeSheet = await this.checkUserTimeSheetIsAvailable(true); // return user time sheet
    if (!this.autoSaveUpdatedTime) {
      this.autoSaveUpdatedTime = await this.getUpdatedTimeOfUserTimeSheet(currentUserTimeSheet.id);
    }
    const userTimeSheet = currentUserTimeSheet;
    const currentUserTotalAttendance = userTimeSheet.get('totalAttendance');
    const isUserInMeeting = userTimeSheet.get('webDesktopDetails');
    const currentUserCurrentStatus = userTimeSheet.get('currentStatus');
    const currentTime = new Date().getTime();
    const updateTime = currentUserTimeSheet.get('updateTime');
    let currentProject = this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
    this.storageConfiguration.sessionSetItem(this.storageConfiguration.userTimeSheetAutoSave, true); // set to true if user in online
    currentProject = JSON.parse(currentProject);
    if (currentUserCurrentStatus === 'work' && isUserInMeeting.meeting === false) { // ! Check user is in Work Mode
      // currentUserTotalAttendance.worktime += (currentTime - updateTime) / 1000;
      currentUserTotalAttendance.worktime += (currentTime - this.autoSaveUpdatedTime) / 1000;
    } else if (currentUserCurrentStatus === 'idle') {  // ! Check user is in Break Mode
      // currentUserTotalAttendance.breaktime += (currentTime - updateTime) / 1000;
      currentUserTotalAttendance.breaktime += (currentTime - this.autoSaveUpdatedTime) / 1000;

    } else if (currentUserCurrentStatus === 'work' && isUserInMeeting.meeting === true) { // ! check user is in Meeting Mode
      // currentUserTotalAttendance.worktime += (currentTime - updateTime) / 1000;

      currentUserTotalAttendance.worktime += (currentTime - this.autoSaveUpdatedTime) / 1000;

    }

    // * sum the current and previous workTime
    if (currentUserCurrentStatus === 'work') {
      // * sum and save actual hours work in the particular project
      // * find project and update the actual hours
      const projectIndex = currentUserTotalAttendance.project.findIndex(({ id }) => id === currentProject.id);
      if (projectIndex !== -1) {
        // currentUserTotalAttendance.project[projectIndex].actualHours += 300;
        currentUserTotalAttendance.project[projectIndex].actualHours += this.autoSaveIntervalMinute * 60; // save the seconds

      } else {
        // * Add the project if not available and the update the actual hours
        const projectObj = {
          'id': currentProject.id,
          'name': currentProject.projectName,
          // 'actualHours': 300
          'actualHours': this.autoSaveIntervalMinute * 60  // save the seconds
        };
        currentUserTotalAttendance.project.push(projectObj);
      }
    }

    userTimeSheet.set('totalAttendance', currentUserTotalAttendance);
    userTimeSheet.set('updateTime', currentTime);
    this.autoSaveUpdatedTime = new Date().getTime();
    this.storageConfiguration.sessionSetItem(this.storageConfiguration.autoSaveUpdatedTime_userTimeSheet, this.autoSaveUpdatedTime);
    userTimeSheet.save().then(() => {
      this.toaster.show('Hours sync Successfully');
    });
  }

  /**
   * User login and create a new userTimesheet record for day (Online Mode)
   * @returns;
   */

  startWork(): void {
    // this.timeCount();
    // * check the user already stated a day already
    if (this.isUserTimeSheetIsAvailableForToday) {
      // this.toaster.warning('You are already stated a day');
      return;
    }
    if (!this.networkStatus) {
      this.toaster.warning('No Internet please check the internet connection to online');
      return;
    }

    let currentProject = this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
    currentProject = JSON.parse(currentProject);
    const currentTime = new Date().getTime();
    const workTime = [
      {
        project: {
          name: currentProject.projectName,
          id: currentProject.id
        },
        inTime: currentTime,
        outTime: 0,
        actualHours: 0
      },
    ];

    const totalAttendance =
    {
      worktime: 0,
      breaktime: 0,
      project: [
        {
          id: currentProject.id,
          name: currentProject.projectName,
          actualHours: 0
        }
      ]
    };

    // * construct object for webDesktop user status
    const webDesktopDetails = this.webDesktopDetailsDynamic('work', '', '', false);

    const UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    const userTimeSheet = new UserTimeSheet();
    userTimeSheet.set('workTime', workTime);
    userTimeSheet.set('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    userTimeSheet.set('tenantId', this.tenantId);
    userTimeSheet.set('isSheetSubmitted', false);
    userTimeSheet.set('currentStatus', 'work');
    userTimeSheet.set('webDesktopDetails', webDesktopDetails);
    userTimeSheet.set('user', { __type: 'Pointer', className: '_User', objectId: this.parseService.instance.User.current().id });
    userTimeSheet.set('breakTime', []);
    userTimeSheet.set('totalAttendance', totalAttendance);
    userTimeSheet.set('inTime', currentTime);
    userTimeSheet.set('isClosed', false);
    userTimeSheet.set('outTime', 0);
    userTimeSheet.set('updateTime', currentTime);
    userTimeSheet.set('agreedStartTime', this.profileDetails.agreedStartTime);
    userTimeSheet.set('isUpdated', false);
    userTimeSheet.set('version', 'web-ver');
    userTimeSheet.save().then(() => {
      this.autoSave();
      this.isUserTimeSheetIsAvailableForToday = true;
      // this.toaster.success('work stated successfully');
      this.currentWorkStatus = 'Work';
    });
  }


  /**
   * User from work, meeting status to Break status (Break Mode)
   * @param breakOrWork (string type either(work or break))
   * @returns;
   */
  async break(breakOrWork): Promise<void> {
    this.clearAllInterval(this.breakToasterInterval, this.meetingToasterInterval); // ! clear break and meeting interval
    let currentProject = this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
    currentProject = JSON.parse(currentProject);
    const currentUserTimeSheet = await this.checkUserTimeSheetIsAvailable(true);
    if (!this.autoSaveUpdatedTime) {
      this.autoSaveUpdatedTime = await this.getUpdatedTimeOfUserTimeSheet(currentUserTimeSheet.id);
    }
    if (!this.networkStatus) {
      this.toaster.warning('No internet connection');
      return;
    }
    const currentTime = new Date().getTime();
    const userTimeSheet = currentUserTimeSheet;

    // * Check user is already in Break state
    const currentUserCurrentStatus = userTimeSheet.get('currentStatus');
    if (currentUserCurrentStatus === 'idle') {
      // this.toaster.warning('You are already in Break');
      return;
    }

    const currentUserBreakTime = userTimeSheet.get('breakTime');
    const breakTimeLength = currentUserBreakTime.length;

    const currentUserWorkTime = userTimeSheet.get('workTime');
    const workTimeLength = currentUserWorkTime.length;


    const currentUserTotalAttendance = userTimeSheet.get('totalAttendance');

    // ! If user is in WORK state and Meeting mode (IF statement)
    const isUserInMeeting = userTimeSheet.get('webDesktopDetails');
    if (currentUserCurrentStatus === 'work' && isUserInMeeting.meeting === true) {

      // * update the last record in the breakTime Array 
      if (currentUserBreakTime) {
        currentUserBreakTime[breakTimeLength - 1].breakHours = currentTime - currentUserBreakTime[breakTimeLength - 1].outTime;
        currentUserBreakTime[breakTimeLength - 1].inTime = currentTime;
      }


      // * sum the current and previous hours for work time from breakTime
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.worktime += (currentTime - currentUserBreakTime[breakTimeLength - 1].outTime) / 1000;
        currentUserTotalAttendance.worktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
      }

      // ! Else user in WORK state (Else statement)
    } else {

      // * update the last record in workTime array
      if (currentUserWorkTime) {
        currentUserWorkTime[workTimeLength - 1].actualHours = currentTime - currentUserWorkTime[workTimeLength - 1].inTime;
        currentUserWorkTime[workTimeLength - 1].outTime = currentTime;
      }

      // * sum the current and previous hours for work time from workTime
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.worktime += (currentTime - currentUserWorkTime[workTimeLength - 1].inTime) / 1000;
        currentUserTotalAttendance.worktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
      }
    }

    // * sum the current and previous workTime
    if (currentUserTotalAttendance) {
      // * sum and save actual hours work in the particular project
      // * find project and update the actual hours
      const projectIndex = currentUserTotalAttendance.project.findIndex(({ id }) => id === currentProject.id);
      if (projectIndex !== -1) {
        currentUserTotalAttendance.project[projectIndex].actualHours = currentTime - currentUserWorkTime[workTimeLength - 1].inTime;
      } else {
        // * Add the project if not available and the update the actual hours
        const projectObj = {
          'id': currentProject.id,
          'name': currentProject.projectName,
          'actualHours': currentTime - currentUserWorkTime.inTime
        };
        currentUserTotalAttendance.project.push(projectObj);
      }
    }

    let webDesktopDetails: any;

    if (breakOrWork === 'break') {
      // * construct the empty object for break array
      if (currentUserBreakTime) {
        const breakObj = {
          'project': {
            'name': currentProject.projectName,
            'id': currentProject.id,
          },
          'outTime': currentTime,
          'inTime': 0,
          'breakHours': 0,
          'reason': {
            'reason': 'Refreshment',
          }
        };
        currentUserBreakTime.push(breakObj);
        userTimeSheet.set('breakTime', currentUserBreakTime);
      }

      // * construct object for webDesktop user status
      webDesktopDetails = this.webDesktopDetailsDynamic('break', 'idle', 'Refreshment', false);
      userTimeSheet.set('currentStatus', 'idle');
    }

    if (breakOrWork === 'work') {

      // * construct the empty object for the workTime Array
      const workTime = [
        {
          project: {
            name: currentProject.projectName,
            id: currentProject.id
          },
          inTime: currentTime,
          outTime: 0,
          actualHours: 0
        },
      ];

      // * push the newly constructed object to the workTime array 
      currentUserWorkTime.push(...workTime);
      // * construct object for webDesktop user status
      webDesktopDetails = this.webDesktopDetailsDynamic('work', '', '', false);
      userTimeSheet.set('currentStatus', 'work');

    }


    userTimeSheet.set('webDesktopDetails', webDesktopDetails);
    userTimeSheet.set('workTime', currentUserWorkTime);
    userTimeSheet.set('totalAttendance', currentUserTotalAttendance);
    userTimeSheet.set('updateTime', currentTime);

    userTimeSheet.save().then(res => {
      this.autoSave();
      // ! alert user is in break for every 5 min
      // this.toaster.success('You are in Break');
      this.currentWorkStatus = breakOrWork === 'break' ? 'Break' : 'Work';
      if (this.currentWorkStatus === 'Break') {
        this.breakToasterInterval = setInterval(() => {
          this.toaster.show('You are in ' + this.currentWorkStatus);
        }, 300000);
      }
    });

  }

  /**
   * * 
   * User from Break, Work status to meeting Status (Meeting Mode)
   * @returns;
   */
  async meeting(): Promise<void> {
    this.clearAllInterval(this.breakToasterInterval, this.meetingToasterInterval); // ! clear break and meeting interval
    let currentProject = this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
    currentProject = JSON.parse(currentProject);
    const currentTime = new Date().getTime();
    const currentUserTimeSheet = await this.checkUserTimeSheetIsAvailable(true);
    const userTimeSheet = currentUserTimeSheet;
    if (!this.autoSaveUpdatedTime) {
      this.autoSaveUpdatedTime = await this.getUpdatedTimeOfUserTimeSheet(currentUserTimeSheet.id);
    }

    // * Check user is already in Meeting (Meeting mode)
    const isUserInMeeting = userTimeSheet.get('webDesktopDetails');
    if (isUserInMeeting.meeting) {
      // this.toaster.warning('you are already in Meeting');
      return;
    }

    const currentUserCurrentStatus = userTimeSheet.get('currentStatus');
    const currentUserBreakTime = userTimeSheet.get('breakTime');
    const breakTimeLength = currentUserBreakTime.length;

    // * construct the webDesktop user status
    const webDesktopDetails = this.webDesktopDetailsDynamic('break', 'work', 'Internal Meeting', true);

    if (currentUserCurrentStatus === 'idle') { //  ! user in break 
      // * update the last record in the breakTime Array 
      if (currentUserBreakTime) {
        currentUserBreakTime[breakTimeLength - 1].breakHours = currentTime - currentUserBreakTime[breakTimeLength - 1].outTime;
        currentUserBreakTime[breakTimeLength - 1].inTime = currentTime;
      }

      // * sum the current and previous breakTime hours
      const currentUserTotalAttendance = userTimeSheet.get('totalAttendance');
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.breaktime += (currentTime - currentUserBreakTime[breakTimeLength - 1].outTime) / 1000;
        currentUserTotalAttendance.breaktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
      }

      // * construct the empty object for break array
      if (currentUserBreakTime) {
        const breakObj = {
          'project': {
            'name': currentProject.projectName,
            'id': currentProject.id,
          },
          'outTime': currentTime,
          'inTime': 0,
          'breakHours': 0,
          'reason': {
            'reason': 'Internal Meeting',
          }
        };
        currentUserBreakTime.push(breakObj);
      }

      userTimeSheet.set('webDesktopDetails', webDesktopDetails);
      userTimeSheet.set('breakTime', currentUserBreakTime);
      userTimeSheet.set('totalAttendance', currentUserTotalAttendance);
      userTimeSheet.set('updateTime', currentTime);
      userTimeSheet.set('currentStatus', 'work');

    } else if (currentUserCurrentStatus === 'work') { // ! user in work

      const currentUserWorkTime = userTimeSheet.get('workTime');
      const workTimeLength = currentUserWorkTime.length;
      // * update the last record in workTime array
      if (currentUserWorkTime) {
        currentUserWorkTime[workTimeLength - 1].actualHours = currentTime - currentUserWorkTime[workTimeLength - 1].inTime;
        currentUserWorkTime[workTimeLength - 1].outTime = currentTime;
      }

      // * sum the current and previous workTime
      const currentUserTotalAttendance = userTimeSheet.get('totalAttendance');
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.worktime += (currentTime - currentUserWorkTime[workTimeLength - 1].inTime) / 1000;
        currentUserTotalAttendance.worktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
        // * sum and save actual hours work in the particular project
        const projectIndex = currentUserTotalAttendance.project.findIndex(({ id }) => id === currentProject.id);
        if (projectIndex !== -1) {
          // * find project and update the actual hours
          currentUserTotalAttendance.project[projectIndex].actualHours = currentTime - currentUserWorkTime[workTimeLength - 1].inTime;
        } else {
          // * Add the project if not available and the update the actual hours
          const projectObj = {
            'id': currentProject.id,
            'name': currentProject.projectName,
            'actualHours': currentTime - currentUserWorkTime.inTime
          };
          currentUserTotalAttendance.project.push(projectObj);
        }
      }

      // * construct the empty object for break array
      if (currentUserBreakTime) {
        const breakObj = {
          'project': {
            'name': currentProject.projectName,
            'id': currentProject.id,
          },
          'outTime': currentTime,
          'inTime': 0,
          'breakHours': 0,
          'reason': {
            'reason': 'Internal Meeting',
          }
        };
        currentUserBreakTime.push(breakObj);
      }

      userTimeSheet.set('workTime', currentUserWorkTime);
      userTimeSheet.set('webDesktopDetails', webDesktopDetails);
      userTimeSheet.set('breakTime', currentUserBreakTime);
      userTimeSheet.set('totalAttendance', currentUserTotalAttendance);
      userTimeSheet.set('updateTime', currentTime);
      userTimeSheet.set('currentStatus', 'work');
    }

    userTimeSheet.save().then(res => {
      this.autoSave();
      this.currentWorkStatus = 'Meeting';
      // ! alert user is in Meeting for every 5 min
      this.meetingToasterInterval = setInterval(() => {
        this.toaster.show('You are in Meeting');
      }, 300000);
    });
  }

  /**
   * User switch from break status to work status
   * @returns;
   */
  async resumeWork(): Promise<void> {
    this.clearAllInterval(this.breakToasterInterval, this.meetingToasterInterval); // ! clear break and meeting interval
    let currentProject = this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
    currentProject = JSON.parse(currentProject);
    const currentTime = new Date().getTime();
    const currentUserTimeSheet = await this.checkUserTimeSheetIsAvailable(true);
    const userTimeSheet = currentUserTimeSheet;

    if (!this.autoSaveUpdatedTime) {
      this.autoSaveUpdatedTime = await this.getUpdatedTimeOfUserTimeSheet(currentUserTimeSheet.id);
    }
    // * Check user is already in working state
    const isUserInMeeting = userTimeSheet.get('webDesktopDetails');
    const currentUserCurrentStatus = userTimeSheet.get('currentStatus');
    if (currentUserCurrentStatus === 'work' && isUserInMeeting.meeting === false) {
      // this.toaster.warning('you are already in Working State');
      return;
    }

    const currentUserBreakTime = userTimeSheet.get('breakTime');
    const workTimeLength = currentUserBreakTime.length;
    const currentUserTotalAttendance = userTimeSheet.get('totalAttendance');
    // ! If user is in WORK state and Meeting mode (IF statement)
    if (currentUserCurrentStatus === 'work' && isUserInMeeting.meeting === true) { // ! In Meeting

      const breakTimeLength = currentUserBreakTime.length;
      // * update the last record in the breakTime Array 
      if (currentUserBreakTime) {
        currentUserBreakTime[breakTimeLength - 1].breakHours = currentTime - currentUserBreakTime[breakTimeLength - 1].outTime;
        currentUserBreakTime[breakTimeLength - 1].inTime = currentTime;
      }


      // * sum the current and previous hours for work time from breakTime
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.worktime += (currentTime - currentUserBreakTime[breakTimeLength - 1].outTime) / 1000;
        currentUserTotalAttendance.worktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
      }

      userTimeSheet.set('breakTime', currentUserBreakTime);
      // * construct the empty object for the workTime Array
      const workTime = [
        {
          project: {
            name: currentProject.projectName,
            id: currentProject.id
          },
          inTime: currentTime,
          outTime: 0,
          actualHours: 0
        },
      ];

      // * push the newly constructed object to the workTime array 
      const currentUserWorkTime = userTimeSheet.get('workTime');
      currentUserWorkTime.push(...workTime);
      userTimeSheet.set('workTime', currentUserWorkTime);

    }
    else if (currentUserCurrentStatus === 'work') {

      // * update the last record in the breakTime Array 
      if (currentUserBreakTime) {
        currentUserBreakTime[workTimeLength - 1].breakHours = currentTime - currentUserBreakTime[workTimeLength - 1].outTime;
        currentUserBreakTime[workTimeLength - 1].inTime = currentTime;
      }

      // * sum the current and previous breakTime hours
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.breaktime += (currentTime - currentUserBreakTime[workTimeLength - 1].outTime) / 1000;
        currentUserTotalAttendance.breaktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
      }

      // * construct the empty object for the workTime Array
      const workTime = [
        {
          project: {
            name: currentProject.projectName,
            id: currentProject.id
          },
          inTime: currentTime,
          outTime: 0,
          actualHours: 0
        },
      ];

      // * push the newly constructed object to the workTime array 
      const currentUserWorkTime = userTimeSheet.get('workTime');
      currentUserWorkTime.push(...workTime);
      userTimeSheet.set('workTime', currentUserWorkTime);
    } else {
      // * update the last record in the breakTime Array 
      if (currentUserBreakTime) {
        currentUserBreakTime[workTimeLength - 1].breakHours = currentTime - currentUserBreakTime[workTimeLength - 1].outTime;
        currentUserBreakTime[workTimeLength - 1].inTime = currentTime;
      }

      // * sum the current and previous breakTime hours
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.breaktime += (currentTime - currentUserBreakTime[workTimeLength - 1].outTime) / 1000;
        currentUserTotalAttendance.breaktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
      }

      // * construct the empty object for the workTime Array
      const workTime = [
        {
          project: {
            name: currentProject.projectName,
            id: currentProject.id
          },
          inTime: currentTime,
          outTime: 0,
          actualHours: 0
        },
      ];

      // * push the newly constructed object to the workTime array 
      const currentUserWorkTime = userTimeSheet.get('workTime');
      currentUserWorkTime.push(...workTime);
      userTimeSheet.set('workTime', currentUserWorkTime);
    }
    // * construct the webDesktop user status
    const webDesktopDetails = this.webDesktopDetailsDynamic('work', '', '', false);

    userTimeSheet.set('webDesktopDetails', webDesktopDetails);
    userTimeSheet.set('breakTime', currentUserBreakTime);
    userTimeSheet.set('totalAttendance', currentUserTotalAttendance);
    userTimeSheet.set('updateTime', currentTime);
    userTimeSheet.set('currentStatus', 'work');
    userTimeSheet.save().then(res => {
      this.autoSave();
      // this.toaster.success('work resumed successfully');
      this.currentWorkStatus = 'Work';
    });
  }

  /**
  * * User login and try to logout (close the day)
  */
  async closeWork(isClosePreviousDay): Promise<void> {
    clearInterval(this.autoSaveInterval); // ! auto save interval
    this.clearAllInterval(this.breakToasterInterval, this.meetingToasterInterval); // ! clear break and meeting interval
    let currentProject = this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
    currentProject = JSON.parse(currentProject);
    let currentUserTimeSheet;
    let userTimeSheet;
    // const currentTime = new Date().getTime();
    let currentTime;
    let currentUserTotalAttendance;
    // If previous day userTimeSheet available and it is not logout then set it to userTimeSheet variable 
    // else use current day user TimeSheet for logout
    if (isClosePreviousDay) {
      currentUserTimeSheet = isClosePreviousDay;
      userTimeSheet = currentUserTimeSheet;
      currentTime = isClosePreviousDay.get('updateTime');
      // return ; // need to remove
    } else {
      currentUserTimeSheet = await this.checkUserTimeSheetIsAvailable(true);
      userTimeSheet = currentUserTimeSheet;
      if (!this.autoSaveUpdatedTime) {
        this.autoSaveUpdatedTime = await this.getUpdatedTimeOfUserTimeSheet(currentUserTimeSheet.id);
      }
      currentTime = this.autoSaveUpdatedTime;
      currentUserTotalAttendance = userTimeSheet.get('totalAttendance');
    }

    const currentUserCurrentStatus = userTimeSheet.get('currentStatus');

    const currentUserBreakTime = userTimeSheet.get('breakTime');
    const breakTimeLength = currentUserBreakTime.length;

    const currentUserWorkTime = userTimeSheet.get('workTime');
    const workTimeLength = currentUserWorkTime.length;

    // ! If user is in WORK state and Meeting mode (IF statement)
    const isUserInMeeting = userTimeSheet.get('webDesktopDetails');
    if (currentUserCurrentStatus === 'work' && isUserInMeeting.meeting === true) { // ! In Meeting

      // * update the last record in the breakTime Array 
      if (currentUserBreakTime) {
        currentUserBreakTime[breakTimeLength - 1].breakHours = currentTime - currentUserBreakTime[breakTimeLength - 1].outTime;
        currentUserBreakTime[breakTimeLength - 1].inTime = currentTime;
      }

      // * sum the current and previous hours in the work time from meeting
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.worktime += (currentTime - currentUserBreakTime[breakTimeLength - 1].outTime) / 1000;
        currentUserTotalAttendance.worktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
      }

      userTimeSheet.set('breakTime', currentUserBreakTime);

    } else if (currentUserCurrentStatus === 'work' && isUserInMeeting.meeting === false) { // ! In Work

      // * update the last record in workTime array
      if (currentUserWorkTime) {
        currentUserWorkTime[workTimeLength - 1].actualHours = currentTime - currentUserWorkTime[workTimeLength - 1].inTime;
        currentUserWorkTime[workTimeLength - 1].outTime = currentTime;
      }

      // * sum the current and previous hours for work time from workTime
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.worktime += (currentTime - currentUserWorkTime[workTimeLength - 1].inTime) / 1000;
        currentUserTotalAttendance.worktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;

      }

      userTimeSheet.set('workTime', currentUserWorkTime);

    } else if (currentUserCurrentStatus === 'idle') {  // ! Break

      // * update the last record in the breakTime Array 
      if (currentUserBreakTime) {
        currentUserBreakTime[breakTimeLength - 1].breakHours = currentTime - currentUserBreakTime[breakTimeLength - 1].outTime;
        currentUserBreakTime[breakTimeLength - 1].inTime = currentTime;
      }

      // * sum the current and previous breakTime hours
      if (currentUserTotalAttendance) {
        // currentUserTotalAttendance.breaktime += (currentTime - currentUserBreakTime[breakTimeLength - 1].outTime) / 1000;
        currentUserTotalAttendance.breaktime += (currentTime - this.autoSaveUpdatedTime + 1000) / 1000;
      }

      userTimeSheet.set('breakTime', currentUserBreakTime);
    }
    // * construct the webDesktop user status
    const webDesktopDetails = this.webDesktopDetailsDynamic('logout', '', '', false);

    userTimeSheet.set('webDesktopDetails', webDesktopDetails);
    userTimeSheet.set('outTime', currentTime);
    userTimeSheet.set('totalAttendance', currentUserTotalAttendance);
    userTimeSheet.set('isSheetSubmitted', true);
    userTimeSheet.set('currentStatus', 'logout');
    userTimeSheet.set('isClosed', true);
    userTimeSheet.save().then(() => {
      // this.toaster.show('Work closed successfully');
      if (isClosePreviousDay) { // close previous day userTimeSheet
        return;
      }
      this.currentWorkStatus = 'Logout';
      this.checkUserTimeSheetIsAvailable();
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.userTimeSheetAutoSave, false); // set to false if user in offline
    });
  }

  /**
   * User logout and login to restart the day
   */
  async restartDay(): Promise<void> {
    let currentProject = this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
    currentProject = JSON.parse(currentProject);
    const currentTime = new Date().getTime();
    const currentUserTimeSheet = await this.checkUserTimeSheetIsAvailable(true);
    const userTimeSheet = currentUserTimeSheet;

    // * construct the empty object for the workTime Array
    const workTime = [
      {
        project: {
          name: currentProject.projectName,
          id: currentProject.id
        },
        inTime: currentTime,
        outTime: 0,
        actualHours: 0
      },
    ];

    // * push the newly constructed object to the workTime array 
    const currentUserWorkTime = userTimeSheet.get('workTime');
    currentUserWorkTime.push(...workTime);

    // * construct the webDesktop user status

    const webDesktopDetails = this.webDesktopDetailsDynamic('work', '', '', false);

    userTimeSheet.set('outTime', 0);
    userTimeSheet.set('webDesktopDetails', webDesktopDetails);
    userTimeSheet.set('workTime', currentUserWorkTime);
    userTimeSheet.set('isSheetSubmitted', false);
    userTimeSheet.set('currentStatus', 'work');
    userTimeSheet.set('isClosed', false);
    userTimeSheet.save().then(() => {
      this.autoSave();
      // this.toaster.show('Work Restarted successfully');
      this.currentWorkStatus = 'Work';
      this.checkUserTimeSheetIsAvailable();
    });
  }

  /**
   * * Get project list that are assigned to the user
   */
  async getProjectList(): Promise<void> {
    const userId = this.parseService.instance.User.current().id;
    const ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    const projectMembers = new this.parseService.instance.Query(ProjectMembers);
    projectMembers.equalTo('user', { __type: 'Pointer', className: '_User', objectId: userId });
    projectMembers.include('project');
    const projectListData = await projectMembers.find();
    this.projectList = [];
    for (const project of projectListData) {
      this.projectList.push({
        id: project.get('project').id,
        role: project.get('role'),
        projectName: project.get('project').get('projectInfo').projectName,
      });
    }
    // console.log('projectList', this.projectList);
  }

  /**
   * Get Login user profile details
   */
  async getUserProfile(): Promise<void> {
    const Profile = this.parseService.instance.Object.extend('Profile');
    const profile = new this.parseService.instance.Query(Profile);
    profile.equalTo('objectId', this.profileId);
    const profileDetails = await profile.find();
    this.profileDetails = {
      agreedStartTime: profileDetails[0].get('officialInfo').startTime,
      isWebDesktop: profileDetails[0].get('isWebDesktop')
    };
  }

  // * Dynamically construct the webDesktop Object
  // * @param states 'Name of the state (String)'
  // * @param breakName 'Name of the Break (String)'
  // * @param breakType 'Name of the Break Type (String)'
  // * @param meeting ' Define user is in meeting (Boolean)'

  webDesktopDetailsDynamic(states, breakName, breakType, meeting): any {
    let currentProject = this.storageConfiguration.sessionGetItem(this.storageConfiguration.projectId);
    currentProject = JSON.parse(currentProject);
    const currentTime = new Date().getTime();
    // * construct the webDesktop user status
    const webDesktopDetails = {
      projectName: currentProject.projectName,
      projectId: currentProject.id,
      status: states,
      breakName: breakName,
      breakType: breakType,
      meeting: meeting,
      currentProjectSelected: currentProject,
      updatedTime: currentTime
    };
    return webDesktopDetails;
  }

  /**
   * When user change the project manually, save the prvious actual hours worked in the project and set the new project in the dropdown
   * @param event;
   */
  async changeProject(event): Promise<void> {
    if (this.isUserTimeSheetIsAvailableForToday) {
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.projectId, JSON.stringify(this.selectedProject));
      this.break('work'); // ! close privious work record and create a new work record
    } else {
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.projectId, JSON.stringify(this.selectedProject));
    }
  }

  /**
   * If user in Break, Meeting, Logout status not allowed to change and show the user status in toastr
   */
  projectChangeValidation(): void {
    if (this.currentWorkStatus === 'Logout' || this.currentWorkStatus === 'Break' || this.currentWorkStatus === 'Meeting') {
      this.toaster.show('You are in ' + this.currentWorkStatus);
    }
    if (this.isTaskInprogress) {
      this.taskRunningValidation(this.selectedProject.id);
    }
  }

  /**
   * If task is inProgress not allowed the user to change project and status (navigate to odo-list-item page )
   * @param projectId (string)
   * @returns ;
   */
  taskRunningValidation(projectId): void {
    if (this.selectedProject.id === projectId && this.isTaskInprogress === true) { // ! Execute if task is inProgress state
      this.toaster.info('Please Hold or Completed the Inprogress Task');
      this.router.navigate(['/todo-list-item']);
      return;
    }
  }

  /**
   * When task started in different project swith to new project in dropdown and save the previous actual hours worked in that project 
   * @param projectId ;
   */
  switchProject(projectId): void {
    this.selectedProject = this.projectList.find(pro => pro.id === projectId);
    // * set the selected project in the local storage
    this.storageConfiguration.sessionSetItem(this.storageConfiguration.projectId, JSON.stringify(this.selectedProject));
    this.break('work'); // * close privious work record and create a new work record
  }

  // * clear all the setInterval
  clearAllInterval(breakId, meetingId): void {
    clearInterval(breakId);
    clearInterval(meetingId);
  }

  /**
   * * Information popup for previous day work close
   */
  previousDayUerTimeSheetLogout(): void {
    this.dialog.open(this.forgotLogoutPopup, {
      width: '350px'
    });
  }

  close(): void {
    this.dialog.closeAll();
  }
  // To check internet connection stability
  checkNetworkStatus(): void {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(status => {
        console.log('status', status);
        this.networkStatus = status;
      });
  }

  ngOnDestroy(): void {
    this.networkStatus$.unsubscribe();
  }
}
